import React, { useEffect, useState } from "react";
import "../../css_files/Signin/Login.css";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import getCookie from "../../api";
import Swal from "sweetalert2";
import LoadingScreen from "../Homepage/LoadingScreen";
import { registerWebPush } from "../registerWebPush";
import axiosInstance from "../../api";

function Login({ setisloggedin }) {
  const [logindata, setlogindata] = useState({
    Username: "",
    Password: "",
  });

  const [loading, setloading] = useState(false);
  const nav = useNavigate();

  function handlesubmit(e) {
    e.preventDefault();
    setloading(true);
    axios
      .post(`${process.env.REACT_APP_API_URL}/api/auth/login`, logindata)
      .then((res) => {
        document.cookie = "token=" + res.data.token;
        setisloggedin(true);
        localStorage.setItem("username", logindata.Username);
        nav("/dashboard");
        setloading(false);
      })
      .catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: err?.response?.data?.error ?? err?.response?.data,
        });
        setloading(false);
      });
  }

  return (
    <section className="login">
      <form onSubmit={handlesubmit}>
        <h1>Login</h1>
        <blockquote>
          <label>Username</label>
          <input
            type="text"
            placeholder="Enter Username"
            onChange={(e) =>
              setlogindata({ ...logindata, Username: e.target.value?.trim() })
            }
            required
          />
        </blockquote>
        <blockquote>
          <label>Password</label>
          <input
            type="password"
            placeholder="Enter Password"
            onChange={(e) =>
              setlogindata({ ...logindata, Password: e.target.value?.trim() })
            }
            required
          />
        </blockquote>
        <button type="submit">Login</button>
      </form>
      <p>
        Not a Member Yet. Click{" "}
        <a
          href="#"
          onClick={() => {
            Swal.fire({
              icon: "warning",
              title: "Register User",
              text: "Please Contact Administrator directly or mail to admin123@gmail.com",
            });
          }}
        >
          Here{" "}
        </a>
        to Register
      </p>
      {loading && <LoadingScreen />}
    </section>
  );
}

export default Login;
